import { render } from "./LearnerDialogic.vue?vue&type=template&id=1cc7c45b&scoped=true"
import script from "./LearnerDialogic.vue?vue&type=script&lang=js"
export * from "./LearnerDialogic.vue?vue&type=script&lang=js"

import "./LearnerDialogic.vue?vue&type=style&index=0&id=1cc7c45b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc7c45b"]])

export default __exports__